import { Color } from '@diritto/common/style/color';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { IconButton } from 'ui-components/common/IconButton';
import { ThreeDots } from 'icons/ThreeDots';
import React from 'react';

interface MoreMenuButtonProps {
  className?: string;
  vertical?: boolean;
  color?: string;
  isOpen: boolean;
  onClick?: () => void;
}

export const MoreMenuButton = ({ className, vertical, color = Color.Black, isOpen, onClick }: MoreMenuButtonProps) => (
  <StyledIconButton className={className} selected={isOpen} onClick={onClick}>
    <StyledThreeDots vertical={vertical} color={color} />
  </StyledIconButton>
);

const StyledIconButton = styled(IconButton)(
  ({ selected }: { selected?: boolean }) => css`
    width: 20px;
    height: 20px;

    ${selected &&
    css`
      border-radius: 50%;
      background: ${Color.Gray200};
    `}
  `,
);

const StyledThreeDots = styled(ThreeDots)(
  ({ vertical }: { vertical?: boolean }) => css`
    transform: rotate(${vertical ? 90 : 0}deg);
  `,
);
